import styled from 'styled-components';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

const Title = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 72px;
  line-height: 89px;
  text-align: right;
  opacity: 0.4;
  color: ${({ $color }) => $color};
`;

const SectionNameMobile = forwardRef(({ title, color }, ref) => {
  return (
    <Title ref={ref} $color={color}>
      {title}
    </Title>
  );
});

SectionNameMobile.displayName = 'SectionNameMobile';

SectionNameMobile.propTypes = {
  title: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
};

export default SectionNameMobile;
